<template>
    <div>
        <div class="top_banner" >
            <div class="top_banner_text">
                <p>招聘信息</p>
                <!--<p>About&nbsp;&nbsp;Us</p>-->
            </div>
        </div>
        <div class="about_us_bg">
            <div class="w_1200 w_1200_boot non_margin">
                <div class="about_us">
                    <div class="employ_details"></div>
                    <div class="employ_details_box">
                        <h6 class="details_title"></h6>
                        <div class="details_type">
                            <p><span>职位类别：</span><span >{{options.categoryName}}</span></p>
                            <p><span>职位名称：</span><span >{{options.position}}</span></p>
                            <p><span>工作地点：</span><span >{{options.workPlaceName}}</span></p>
                            <p><span>发布时间：</span><span >{{options.createDate}}</span></p>
                        </div>
                        <div class="details_content" v-html="options.publishContext">
                        </div>
                        <div class="details_content">
                            <p style="margin-bottom: 0"><span>联系方式：</span><span >{{options.phone}}</span></p>

                            <p style="margin-bottom: 0"><span>简历投递邮箱：</span><span >{{model.resumeDeliver}}</span></p>
                        </div>
                        <div class="details_btn">
<!--                            <a href="javascript:;" class="apply" @click="add_auth = true , get_model()">立即申请</a>-->
                            <a href="javascript:;" class="reback" @click="$router.go(-1)">返回</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" v-dialogDrag title="联系方式" :visible.sync="add_auth" center class="el_dialoge">

            <el-form ref="form" :model="model" label-width="150px">
                <el-form-item label="简历投递邮箱">
                    <el-input v-model="model.resumeDeliver" disabled></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="model.serviceHotline" disabled></el-input>
                </el-form-item>
            </el-form>

            <el-divider></el-divider>



        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "aboutUsEmployDetail",
        data(){
            return{
                options:{},
                add_auth:false,
                model:{}
            }
        },
        mounted() {
            this.get_data()
            this.get_model()
        },
        methods:{
            get_data(){
                this.$SIF.httpGet({
                    url: this.$SIF._serve.menhu + "/recruit/getMenhuNotice/"+ this.$route.params.id,
                    succFun: res => {
                        this.options = res.data;

                    }, failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_model(){
                this.$SIF.httpGet({
                    url: this.$SIF._serve.menhu + "/company/query",
                    succFun: res => {
                        this.model = res.data[0];
                    }, failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .top_banner {
        background-image: url(~@/assets/img/banner/head_bar_about.png);
        background-size: 100% 100%;

    }
</style>